import { useEffect, useState } from "react";
import { auth } from "./firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";

import Login from "./components/Login";
import HomePage from "./pages/HomePage";
import TestPage from "./pages/TestPage";
import { TestProvider } from "./context/TestContext";

function App() {
  const [user, setUser] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null);
    });

    return () => unsubscribe();
  }, []);

  // ✅ SVE return logike IDE OVDJE

  if (!user) {
    return <Login />;
  }

  if (selectedTest) {
    return (
      <TestProvider initialTest={selectedTest}>
        <TestPage
          user={user}
          test={selectedTest}
          onExit={() => setSelectedTest(null)}
        />
      </TestProvider>
    );
  }

  return (
    <HomePage
      user={user}
      onStartTest={(test) => setSelectedTest(test)}
    />
  );
}

export default App;
